import { styled, View } from '~/lite'

export const StickySearchButtonContainer = styled(View)`
  position: sticky;
  bottom: 0;
  background-color: ${props => props.theme.cardBackground};
`
